export default __webpack_public_path__ + "static/media/hsi-logo.baeefcae.png";